// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options,
  collectFreeGc,
  getTokensState,
  getFreeGcConfiguration,
} from '../sdk.gen'
import { type UseMutationOptions, queryOptions } from '@tanstack/react-query'
import type {
  CollectFreeGcData,
  CollectFreeGcError,
  GetStateData,
  GetConfigurationData,
} from '../types.gen'
import { client as _heyApiClient } from '../client.gen'

export const collectFreeGcMutation = (
  options?: Partial<Options<CollectFreeGcData>>,
): UseMutationOptions<
  unknown,
  CollectFreeGcError,
  Options<CollectFreeGcData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    CollectFreeGcError,
    Options<CollectFreeGcData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await collectFreeGc({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    _infinite?: boolean
  },
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl,
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const getTokensStateQueryKey = (options?: Options<GetStateData>) =>
  createQueryKey('getState', options)

export const getTokensStateOptions = (options?: Options<GetStateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTokensState({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getTokensStateQueryKey(options),
  })
}

export const getFreeGcConfigurationQueryKey = (
  options?: Options<GetConfigurationData>,
) => createQueryKey('getConfiguration', options)

export const getFreeGcConfigurationOptions = (
  options?: Options<GetConfigurationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFreeGcConfiguration({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getFreeGcConfigurationQueryKey(options),
  })
}
